<template>
  <div class="full-screen">

    <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'App',

  components: {
 
  },

  data: () => ({
    
  }),
 async mounted(){
  
 }
}
</script>
<style lang="scss">
@import '@/assets/style/setting.scss';
@import '@/assets/style/font.css';
@import '@/assets/style/assemble.scss';


.full-screen {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    
    /* background-color: lightblue; /*배경색을 확인하기 위한 예시 */
}

</style>
